/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Title_Filter_TestInputs */

const en_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const de_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const fr_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const es_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const it_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const nl_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const pl_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const fi_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const da_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

const sv_portal_scanner_title_filter_test = /** @type {(inputs: Portal_Scanner_Title_Filter_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Filter Test`)
};

/**
* | output |
* | --- |
* | "Title Filter Test" |
*
* @param {Portal_Scanner_Title_Filter_TestInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_title_filter_test = /** @type {((inputs?: Portal_Scanner_Title_Filter_TestInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Title_Filter_TestInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_title_filter_test(inputs)
	if (locale === "fr") return fr_portal_scanner_title_filter_test(inputs)
	if (locale === "es") return es_portal_scanner_title_filter_test(inputs)
	if (locale === "it") return it_portal_scanner_title_filter_test(inputs)
	if (locale === "nl") return nl_portal_scanner_title_filter_test(inputs)
	if (locale === "pl") return pl_portal_scanner_title_filter_test(inputs)
	if (locale === "fi") return fi_portal_scanner_title_filter_test(inputs)
	if (locale === "da") return da_portal_scanner_title_filter_test(inputs)
	if (locale === "sv") return sv_portal_scanner_title_filter_test(inputs)
	return en_portal_scanner_title_filter_test(inputs)
});